import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'
import errorCatcher from '../../utils/errorCatcher'
import Loader from '../../components/loader/Loader'
import { useStyle } from './style'
import { useMediaQuery } from 'react-responsive'
import parse from 'html-react-parser'
import { ClassValue } from 'classnames/types'
import classNames from 'classnames'
import { PageModel } from '../../types/footer/footer_model'
import { AccessibilityModel } from '../../types/accessibility/accessibilityModel'
import portalsEnum from '../../enums/portalsEnum'

const ID_CGU = 'get_cgu'
const INITIAL_STATE: PageModel = {
	id: '',
	content: '',
	title: ''
}

const Cgu = () => {
	const accessibility: AccessibilityModel = {
		isVisualHandicap: false
	}
	const classes = useStyle({ accessibility })
	const intl = useIntl()
	const dispatch = useDispatch()
	const [cgu, setCgu] = useState<PageModel>(INITIAL_STATE)
	const [loading, setLoading] = useState<boolean>(true)

	const isLargeScreen = useMediaQuery(
		{
			query: '(min-width: 1025px)'
		}
	)

	const detailContainerClass: ClassValue = classNames(
		classes.detailsContainerStyle,
		isLargeScreen ? classes.detailsContainerLargeScreenStyle : classes.detailsContainerSmallScreenStyle
	)

	const textContainerClass: ClassValue = classNames(
		classes.textContainerStyle,
		{
			[classes.textContainerLargeScreenStyle]: isLargeScreen,
			[classes.textContainerSmallScreenStyle]: !isLargeScreen
		}
	)

	const titleClass: ClassValue = classNames(
		classes.title1,
		classes.colorAccessibility,
		classes.titleStyle
	)

	useEffect(
		() => {
			fetch(`/api/ec_${process.env.REACT_APP_TARGET}/information/getFooterInfos?language=${intl.locale}&activityLine=${window.origin.includes(portalsEnum.campus) ? portalsEnum.campus : portalsEnum.residence}`)
				.then(
					(response: Response) => response.json()
						.then(
							(cguResponse: PageModel[]) => setCgu(cguResponse[0])
						)
				)
				.catch(
					(error: any) => dispatch(
						errorCatcher(error, ID_CGU)
					)
				)
				.finally(
					() => setLoading(false)
				)
		}, [dispatch, intl.locale]
	)

	if (loading) {
		return <Loader />
	}

	return (
		<div className={isLargeScreen ? classes.cguContainerLargeScreenStyle : classes.cguContainerSmallScreenStyle}>
			<div className={detailContainerClass}>
				<div className={textContainerClass}>
					<div>
						<h1 className={titleClass}>{cgu.title}</h1>

						<span>
						{parse(cgu.content || '')}
					</span>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Cgu